
//加载css与js文件
const appDomainRoot = window.resPath ? `${window.resPath}/fe_components/emap-flow/signature` : `http://res.wisedu.com/fe_components/emap-flow/signature`
const jquerySrc = window.resPath ? `${window.resPath}/bower_components/jquery/dist/jquery.min.js` : 'http://res.wisedu.com/bower_components/jquery/dist/jquery.min.js'
const isMobile = 'ontouchstart' in window
export default function asyncLoadJs (url) {
  return new Promise((resolve, reject) => {
    let srcArr = document.getElementsByTagName("script");
    let hasLoaded = false;
    for (let i = 0; i < srcArr.length; i++){//判断当前js是否加载上
      hasLoaded = (srcArr[i].src==url)?true:false;
      if (hasLoaded) {
        break;
      }
    }
    if (hasLoaded) {
      resolve();
      return;
    }
    let script = document.createElement('script')
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    }
    script.onerror = () => {
      reject();
    }
  })
}

export function loadCss(url){
  let css = document.createElement('link');
  css.href = url;
  css.rel = 'stylesheet';
  css.type = 'text/css';
  document.head.appendChild(css);
}


export function loadMbKingGrid() {
  //加载css
  loadCss( appDomainRoot + "/kinggrid/dialog/artDialog/ui-dialog.css");
  loadCss( appDomainRoot + "/kinggrid/core/kinggrid.plus.css");
  loadCss( appDomainRoot + "/kinggrid/core/kinggrid.plus.mobile.css");
  //加载js
  return new Promise((resolve, reject) => {
    asyncLoadJs(jquerySrc).then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/core/kinggrid.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/core/kinggrid.plus.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/dialog/artDialog/dialog-min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/signature.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/signature.mobile.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/html2canvas.min.js")
    })
    .then(() => {
      resolve()
    })
    .catch(err => {
      reject(err)
    })
  })
}

export function loadPcKingGrid() {
  //加载css
  loadCss( appDomainRoot + "/kinggrid/dialog/artDialog/ui-dialog.css");
  loadCss( appDomainRoot + "/kinggrid/core/kinggrid.plus.css");
  //加载js
  return new Promise((resolve, reject) => {
    asyncLoadJs(jquerySrc).then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/core/kinggrid.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/core/kinggrid.plus.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/dialog/artDialog/dialog-min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/signature.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/signature.pc.min.js")
    })
    .then(() => {
      return asyncLoadJs(appDomainRoot + "/kinggrid/html2canvas.min.js")
    })
    .then(() => {
      resolve()
    })
    .catch(err => {
      reject(err)
    })
  })
}

export function loadKingGridRes() {
  if (isMobile) {
    return loadMbKingGrid()
  } else {
    return loadPcKingGrid()
  }
}

export function loadEseal() {
  console.log('loadEseal')
  //加载css
  loadCss( appDomainRoot + "/esignature/css/style.css");
  //加载js
  return new Promise((resolve, reject) => {
    asyncLoadJs(appDomainRoot + "/esignature/js/crypto-js.js")
      .then(() => {
        return asyncLoadJs(appDomainRoot + "/esignature/js/qrcode.min.js")
      })
      .then(() => {
        return asyncLoadJs(appDomainRoot + "/kinggrid/html2canvas.min.js")
      })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}